import React, { useEffect, useRef } from 'react';

export default function NewsTicker({ settings, onSetPage, courses }) {
  const items   = settings?.ticker_items  || [];
  const enabled = settings?.ticker_enabled !== false;
  const speed   = settings?.ticker_speed  || 30;
  const bg      = settings?.ticker_bg     || '#1a1a2e';
  const trackRef = useRef(null);
  const rafRef   = useRef(null);
  const posRef   = useRef(0);

  useEffect(() => {
    if (!trackRef.current || !enabled || items.length === 0) return;
    const el = trackRef.current;
    const step = () => {
      posRef.current -= (speed / 60);
      if (posRef.current < -(el.scrollWidth / 2)) posRef.current = 0;
      el.style.transform = `translateX(${posRef.current}px)`;
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [items, speed, enabled]);

  if (!enabled || items.length === 0) return null;

  const doubled = [...items, ...items];

  const handleClick = (item) => {
    if (!item.link) return;
    // لو رابط داخلي (academy, agency, contact)
    if (['academy','agency','contact','mycourses'].includes(item.link)) {
      onSetPage?.(item.link);
    } else {
      window.open(item.link, '_blank');
    }
  };

  return (
    <div style={{
      background: bg, overflow: 'hidden', height: '34px',
      display: 'flex', alignItems: 'center',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
      position: 'relative', zIndex: 39,
    }}>
      {/* تسمية ثابتة */}
      <div style={{
        flexShrink: 0, padding: '0 14px',
        background: 'linear-gradient(135deg,#5a67d8,#764ba2)',
        height: '100%', display: 'flex', alignItems: 'center',
        gap: '6px', fontSize: '12px', fontWeight: 'bold', color: '#fff',
        whiteSpace: 'nowrap', zIndex: 2,
      }}>
        📢 أخبار
      </div>

      {/* المحتوى المتحرك */}
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}
        onMouseEnter={() => cancelAnimationFrame(rafRef.current)}
        onMouseLeave={() => {
          const el = trackRef.current;
          if (!el) return;
          const step = () => {
            posRef.current -= (speed / 60);
            if (posRef.current < -(el.scrollWidth / 2)) posRef.current = 0;
            el.style.transform = `translateX(${posRef.current}px)`;
            rafRef.current = requestAnimationFrame(step);
          };
          rafRef.current = requestAnimationFrame(step);
        }}
      >
        <div ref={trackRef} style={{
          display: 'flex', alignItems: 'center',
          whiteSpace: 'nowrap', willChange: 'transform',
        }}>
          {doubled.map((item, i) => (
            <span key={i}
              onClick={() => handleClick(item)}
              style={{
                fontSize: '13px', color: item.color || '#ffffff',
                fontFamily: 'Cairo, Arial, sans-serif',
                padding: '0 32px',
                cursor: item.link ? 'pointer' : 'default',
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                textDecoration: item.link ? 'underline' : 'none',
                textUnderlineOffset: '3px',
                textDecorationColor: 'rgba(255,255,255,0.4)',
                transition: 'opacity 0.15s',
              }}
              onMouseEnter={e => { if (item.link) e.currentTarget.style.opacity = '0.75'; }}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            >
              {item.text}
              <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '14px' }}>◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
